/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import { MyProfileAbout } from 'v4/snippets/profile/about';
import { ProfileLayout } from 'v4/snippets/profile/layout';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';

const Profile = () => {
  return (
    <AuthenticatedProviders>
      <ProfileLayout active={1}>
        <MyProfileAbout />
      </ProfileLayout>
    </AuthenticatedProviders>
  );
};

export default Profile;
